import { EventReportFilter } from '@contexts/event-report/event-report-context.type';
import { EventSalesStatsParams, EventSalesStatsResponse } from '@domain/event-report';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const createEventSalesStatsKey = (eventId: string | undefined, params: EventReportFilter | undefined) => {
  return [QUERY_KEYS.eventSalesStats, eventId, params];
};

const getCompanyEventStats = async ({ eventId, params }: EventSalesStatsParams) => {
  const queryParams = paramsSerializer({ ...params });
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/events/${eventId}/sales-stats?${queryParams}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEventSalesStats = ({ eventId, params, options }: EventSalesStatsParams) => {
  return useGenericQuery<EventSalesStatsResponse, RequestError>(
    createEventSalesStatsKey(eventId, params),
    () => getCompanyEventStats({ eventId, params }),
    {
      ...options,
    }
  );
};
